export const MouseStatus = {
  Init: 0,
  Down: 1,
  Move: 2,
};
export const cofig = {};
